// API клиент для справочников
import { apiClient } from './client'

// Типы для справочников
export interface Filial {
  fil_code: number
  fil_name: string
}

export interface Service {
  serv_code: number
  serv_name: string
  description?: string | null
  is_active: boolean
}

export interface ServiceListResponse {
  items: Service[]
  total: number
}

export interface Department {
  id_otd: string
  ot_per: string
  code_otd_name_full: string
  fil_code?: number
  fil_name?: string
  serv_name?: string
  otd_prof_type?: string
  status?: string
}

export interface PlanIndicator {
  id_otd: string
  ot_per: string
  kf_total_fact?: number
  kf_total_prikaz?: number
  kf_reserve?: number
  kf_work_plan?: number
  kz_avg_plan_gen?: number
  cases_plan_gen?: number
  cases_plan_extr?: number
  cases_plan_plan?: number
  income_plan_gen?: number
}

// Филиалы
export const fetchFilials = async (): Promise<Filial[]> => {
  const response = await apiClient.get('/refs/filials')
  return response.data
}

export const createFilial = async (filial: { fil_code: number; fil_name: string }): Promise<Filial> => {
  const response = await apiClient.post('/refs/filials', filial)
  return response.data
}

export const updateFilial = async (
  fil_code: number,
  data: { fil_name?: string }
): Promise<Filial> => {
  const response = await apiClient.put(`/refs/filials/${fil_code}`, data)
  return response.data
}

export const deleteFilial = async (fil_code: number): Promise<void> => {
  await apiClient.delete(`/refs/filials/${fil_code}`)
}

// Службы
export const fetchServices = async (activeOnly: boolean = true): Promise<Service[]> => {
  const response = await apiClient.get<ServiceListResponse>('/refs/services', {
    params: { active_only: activeOnly }
  })
  return response.data.items
}

export const createService = async (service: { serv_name: string; description?: string }): Promise<Service> => {
  const response = await apiClient.post('/refs/services', service)
  return response.data
}

export const updateService = async (
  serv_code: number,
  data: { serv_name?: string; description?: string; is_active?: boolean }
): Promise<Service> => {
  const response = await apiClient.put(`/refs/services/${serv_code}`, data)
  return response.data
}

export const deleteService = async (serv_code: number): Promise<void> => {
  await apiClient.delete(`/refs/services/${serv_code}`)
}

// Отделения
export interface DepartmentFilters {
  ot_per?: string
  fil_code?: number
  otd_prof_type?: string
}

export const fetchDepartments = async (
  filters?: DepartmentFilters
): Promise<Department[]> => {
  const response = await apiClient.get('/refs/departments', { params: filters })
  return response.data
}

export const updateDepartment = async (
  id_otd: string,
  ot_per: string,
  data: Partial<Department>
): Promise<Department> => {
  const response = await apiClient.put(`/refs/departments/${encodeURIComponent(id_otd)}`, data, {
    params: { ot_per }
  })
  return response.data
}

export const batchUpdateDepartments = async (updates: Array<{ id_otd: string; ot_per: string; data: Partial<Department> }>): Promise<void> => {
  await apiClient.put('/refs/departments/batch', updates)
}

// Плановые показатели
export interface PlanIndicatorFilters {
  ot_per?: string
  fil_code?: number
  otd_prof_type?: string
}

export const fetchPlanIndicators = async (
  filters?: PlanIndicatorFilters
): Promise<PlanIndicator[]> => {
  const response = await apiClient.get('/refs/plan-indicators', { params: filters })
  return response.data
}

export const updatePlanIndicators = async (
  updates: PlanIndicator[]
): Promise<PlanIndicator[]> => {
  const response = await apiClient.put('/refs/plan-indicators', { updates })
  return response.data
}

